import { createContext, useContext } from 'react';

type JonumSelfExclusionGateContext = {
  openJonumSelfExclusion: (message: string) => void;
};

export const JonumSelfExclusionGateContext =
  createContext<JonumSelfExclusionGateContext | null>(null);

export const useJonumSelfExclusionGateContext = () =>
  useContext(JonumSelfExclusionGateContext);
